export default __webpack_public_path__ + "static/media/z020mi0a.c4dd4bb3.mp3";